/**
 * Inline Bunny.net stream embed used by the learning lesson renderer.
 * Props mirror the usage in JsonNotionRenderer's VideoBlock:
 *   { libraryId, videoId }
 */
function BunnyVideo({ libraryId = "231224", videoId }) {
  if (!videoId) return null;

  return (
    <div
      style={{
        position: "relative",
        paddingTop: "56.25%",
        width: "100%",
      }}
    >
      <iframe
        src={`https://player.mediadelivery.net/embed/${libraryId}/${videoId}?autoplay=false&loop=false&muted=false&preload=true&responsive=true`}
        loading="lazy"
        style={{
          border: 0,
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
        }}
        allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
        allowFullScreen
      />
    </div>
  );
}

export default BunnyVideo;
